import { get } from 'lodash'
import { GRAPHQL_ERROR } from 'constants/common'
import { type CartContextInterface } from 'providers/cart'
import {
  type RemoveCouponMutationFn,
  type RemovePromoCodeMutationFn,
} from 'types/graphql-generated'

export const createCheckoutAndCartErrorHandler =
  (
    cart: CartContextInterface['cart'],
    removePromoCodeMutation: RemovePromoCodeMutationFn,
    removeCouponMutation: RemoveCouponMutationFn
  ) =>
  ({ graphQLErrors }: any) => {
    if (graphQLErrors) {
      if (
        graphQLErrors.some(
          (error) => error.name === GRAPHQL_ERROR.PROMO_CODE_ERROR
        )
      ) {
        removePromoCodeMutation({
          variables: { promoCode: get(cart, ['promoCode', 'code']) },
        })
      }
      if (
        graphQLErrors.some(
          (error) => error.name === GRAPHQL_ERROR.COUPON_VALIDATION_ERROR
        )
      ) {
        removeCouponMutation({
          variables: { couponCode: get(cart, ['couponCode', 'code']) },
        })
      }
    }
  }
